import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/board.webp";
import classroomImage from "../../Images/gov-body/room.webp";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Row } from "react-bootstrap";
import "../../Placement.css";
import mom from "../../Images/Ordinances andStatute/MOM of BOM meeting 25112022.pdf";

// const governingBodyMembers = [
//     {
//         sr: 1,
//         name: "Dr. Vinay Agrawal",
//         designation: "Chairman",
//         remarks: "Chancellor, ISBM University",
//     },
//     {
//         sr: 2,
//         name: "Prof.(Dr) Anand Mahalwar",
//         designation: "Member",
//         remarks: "Vice Chancellor, ISBM University",
//     },
//     {
//         sr: 3,
//         name: "Mrs. Pramila Mahesh Agrawal",
//         designation: "Member",
//         remarks: "Nominee, Sponsoring Body, ISBM University",
//     },
//     {
//         sr: 4,
//         name: "Shri Mahesh Ratanlal Agrawal",
//         designation: "Member",
//         remarks: "Nominee, Sponsoring Body, ISBM University",
//     },
//     {
//         sr: 5,
//         name: "Shri Yashwanth Raj Parasmal",
//         designation: "Member",
//         remarks: "Nominee, Sponsoring Body, ISBM University",
//     },
//     {
//         sr: 6,
//         name: "Dr. Sarita Sinha",
//         designation: "Member",
//         remarks: "Principal (Retd.), Govt. Mata Karma Girls College, Mahasamund (CG)",
//     },
//     {
//         sr: 7,
//         name: "Dr. Madan Lal Lakhanpal",
//         designation: "Member",
//         remarks: "Principal (Retd.), Govt. Danteshwari Girls PG College, Jagdalpur (CG)",
//     },
//     {
//         sr: 8,
//         name: "Dr. Sheela Tiwari",
//         designation: "Member",
//         remarks: "Principal (Retd.), Govt. PG College, Bilaspur (CG)",
//     },
//     {
//         sr: 9,
//         name: "Dr. Barada Prasad Bhol",
//         designation: "Member Secretary",
//         remarks: "Registrar, ISBM University",
//     },
// ];

const pedagogyItems = [
  {
    icon: "📝",
    title: "Sanctioning",
    description:
      "To consider the sanction of teaching and non-teaching posts of the University and to recommend them to the Governing Body for approval.",
  },
  {
    icon: "📝",
    title: "Financial Approval",
    description:
      "To get the financial approval of the Governing Body before implementing such decisions.",
  },
  {
    icon: "📝",
    title: "Selection Committee",
    description:
      "To consider and approve the minutes of the selection committee for the appointment of teaching and non-teaching posts.",
  },
  {
    icon: "📝",
    title: "Proposal",
    description:
      "To propose a fee structure to the competent authority for various programmes run by the University.",
  },
  {
    icon: "📝",
    title: "Responsibilities",
    description:
      "To perform any other functions which may be assigned by the Governing Body/Chancellor.",
  },
];

const body = [
  {
    name: "Prof. (Dr) Anand Mahalwar",
    designation: "Chairperson",
    remarks: "Vice Chancellor, ISBM University",
  },
  {
    name: "Ms. Bindu Mahesh Agrawal",
    designation: "Member",
    remarks: "Nominee, Sponsoring Body, ISBM University",
  },
  {
    name: "Shri Jitendra Nahar",
    designation: "Member",
    remarks: "Nominee, Sponsoring Body, ISBM University",
  },
  {
    name: "Dr. Ashok Kumar Nema",
    designation: "Member",
    remarks:
      "Associate Professor (Retd.), Pt. Ravi Shankar Shukla University. Nominee & Representative, State Govt.",
  },
  {
    name: "Dr. C. L. Patel",
    designation: "Member",
    remarks:
      "Principal (Retd.), Govt. College Mahasamund (CG). Nominee & Representative, State Govt.",
  },
  {
    name: "Dr. N. Kumar Swamy",
    designation: "Member",
    remarks:
      "Associate Professor & Dean (In-charge), Faculty of Sciences, ISBM University",
  },
  {
    name: "Dr. Poonam Verma",
    designation: "Member",
    remarks: "Associate Professor & HOD, Faculty of Science",
  },
  {
    name: "Dr. Garima Diwan",
    designation: "Member",
    remarks:
      "Associate Prof. & HOD, School of Arts & Humanities, ISBM University",
  },
  {
    name: "Dr. Sandeep Sahu",
    designation: "Member",
    remarks: "DSW & Assistant Professor, Faculty of Arts & Humanities",
  },
  {
    name: "Dr. Barada Prasad Bhol",
    designation: "Member Secretary",
    remarks: "Registrar, ISBM University",
  },
  {
    name: "Mr. David Mc Loughlin",
    designation: "Adjunct Member",
    remarks: "Educationist, United Kingdom",
  },
  {
    name: "Mr. Ian Whitehead",
    designation: "Adjunct Member",
    remarks: "Educationist, United Kingdom",
  },
];

const BoardManagement = () => {
  return (
    <>
      <title>Board of Management – ISBM University | Strategic Leadership</title>
      <meta
        name="description"
        content="Meet the Board of Management at ISBM University, guiding strategic decisions, academic policies, and institutional growth for excellence in education."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>The Board of Management body under the provisions</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Board of Management
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container-xxl ptb-50">
          <Row className="m-0">
            <div className="col-md-6">
              <h2 className="modern-title text-blue">Board of Management</h2>
              <div className="underline-divider mb-3"></div>
              <p className="text-muted">
                The Board of Management at ISBM University functions as the
                principal executive authority and operates under the statutory
                framework of the Chhattisgarh Private Universities
                (Establishment and Operation) Act, 2005. It plays a pivotal role
                in driving the strategic and administrative direction of the
                University. Comprising experienced academic and administrative
                professionals, the Board is entrusted with formulating policies,
                overseeing academic planning, ensuring quality standards, and
                managing institutional development.
              </p>
              <p className="text-muted">
                The nominated members of the Board serve a tenure of three
                years, during which they contribute to shaping the vision and
                operational excellence of ISBM University, ensuring it remains
                aligned with its mission of providing innovative and impactful
                education.
              </p>
            </div>
            <div className="col-md-6">
              <div className="governing-image-wrapper shadow">
                <img src={classroomImage} alt="Governing Body" />
              </div>
            </div>
          </Row>
        </div>
      </section>

      <section className="container-xxl ptb-50">
        <h2 className="text-center modern-title text-blue">
          Powers and functions of the Board of Management
        </h2>
        <div className="underline-center mb-5"></div>
        <div className="row m-0">
          {pedagogyItems.map((item, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="d-flex h-100 border-lg-end border-none pe-3">
                <div className="me-3 fs-1 text-secondary">{item.icon}</div>
                <div>
                  <h6 className="fw-bold mb-2 text-dark">{item.title}</h6>
                  <p className="text-muted small mb-0">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center fw-bold mb-3">Members</h2>
                    <div className="underline-center mb-5"></div>
                    <div className="row m-0">
                        <div className="col-lg-6 d-flex">
                            <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                <h4 className="fw-bold mb-3">
                                    Member of the Governing Body
                                </h4>
                                <div className="underlinetwo mb-4"></div>

                                <div className="visahead">
                                    <h5 className="text-dark">
                                        Dr. Vinay Agrawal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Chairman</li>
                                    <li>Chancellor ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Prof.(Dr) Anand Mahalwar
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Vice Chancellor ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Mrs. Pramila Mahesh Agrawal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Nominee, Sponsoring Body, ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Shri Mahesh Ratanlal Agrawal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Nominee, Sponsoring Body, ISBM University   </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-6 d-flex">
                            <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                <div className="visahead">
                                    <h5 className="text-dark">
                                        Shri Yashwanth Raj Parasmal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Nominee, Sponsoring Body, ISBM University</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Sarita Sinha
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Principal (Retd.) Govt. Mata Karma Girls College, Mahasamund (CG). Nominee & Representative of State Govt.</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Madan Lal Lakhanpal
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Principal (Retd.) Govt. Danteshwari Girls Postgraduate College, Jagdalpur (CG). Nominee & Representative of State Govt.</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Sheela Tiwari
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member</li>
                                    <li>Principle (Retd.) Govt. P.G. College, Bilashpur (CG). Nominee & Representative of State Govt.</li>
                                </ul>

                                <div className="visahead mt-3">
                                    <h5 className="text-dark">
                                        Dr. Barada Prasad Bhol
                                    </h5>
                                </div>
                                <ul>
                                    <li>Member Secretary</li>
                                    <li>Registrar, ISBM University</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

      <section className="visa-section py-5 bg-light">
        <div className="container-xxl">
          <h2 className="text-center modern-title text-blue">Member of the Board of Management</h2>
          <div className="underline-center mb-5 mx-auto"></div>
          <div className="row m-0">
            {body.map((member, index) => (
              <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                  <div className="visahead">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="text-dark mb-0">{member.name}</h5>
                      <span className="badge designation ms-2 ">
                        {member.designation}
                      </span>
                    </div>
                    <div className="underlinetwo"></div>
                  </div>
                  <ul className="mb-0 list-unstyled">
                    <li>{member.remarks}</li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="meeting">
        <div className="edu_letter_main_wrapper container-xxl">
          <div className="container-xxl">
            <div className="row p-4 ">
              {/* Left Side Text */}
              <div className="col-md-6 d-flex flex-column justify-content-center">
                <h3 className="text-white fw-bold m-0">
                  MOM of Board of Management meeting
                </h3>
              </div>

              {/* Right Side Button */}
              <div className="col-md-6 text-md-end text-center">
                <div className="d-flex flex-column align-items-md-end gap-3">
                  <a
                    href={mom}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn download border fw-bold px-5 p-2"
                  >
                    Download MOM
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BoardManagement;
